module.exports = __webpack_public_path__ + "img/albumcover02.6519d409.jpg";